import React from 'react';
import PropTypes from 'prop-types';

const Reports = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='reports-title'>{altText}</title>
      <path fill='currentColor' fillRule='evenodd' d='M7.283 4.25a2.4 2.4 0 0 1 2.367-2h4.7a2.4 2.4 0 0 1 2.367 2h.783a2.25 2.25 0 0 1 2.25 2.25v13a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-13A2.25 2.25 0 0 1 6.5 4.25h.783Zm1.467.4v1.6h6.5v-1.6a.9.9 0 0 0-.9-.9h-4.7a.9.9 0 0 0-.9.9Zm8 2.35a.75.75 0 0 1-.75.75H8A.75.75 0 0 1 7.25 7V5.75H6.5a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h11a.75.75 0 0 0 .75-.75v-13a.75.75 0 0 0-.75-.75h-.75V7ZM9 10.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75Zm6 1a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Zm-3 2a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z' clipRule='evenodd'/>
    </svg>
  );
};

Reports.propTypes = {
  altText: PropTypes.string
};

export default Reports;
